module.exports = __webpack_public_path__ + "static/clip-ecbaddf91f5d2b2dba3e67c8b6ea0d88.png";